import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from './context/ThemeContext';
import { AudioPlayerProvider } from './context/AudioPlayerContext';
import { ToastProvider } from './context/ToastContext';
import { bootstrap } from 'shared/data/episodeRepository';
import './i18n/config';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

async function start() {
  await bootstrap();

  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <ThemeProvider>
          <ToastProvider>
            <AudioPlayerProvider>
              <App />
            </AudioPlayerProvider>
          </ToastProvider>
        </ThemeProvider>
      </BrowserRouter>
    </React.StrictMode>
  );
}

start();

reportWebVitals();
